class EventBus {
  on(event, callback) {
    // componentDidMount() {
    //   window.eventBus.on("couponApply", (data) =>
    //     console.log(data)
    //   );
    // }
    document.addEventListener(event, (e) => callback(e.detail));
  }
  dispatch(event, data) {
    // window.eventBus.dispatch("couponApply", { message: "coupone applied" })
    console.log('=== Event fired: ' + event + ' ===')
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  }
  remove(event, callback) {
    // window.eventBus.remove("couponApply")
    document.removeEventListener(event, callback);
  }
}
  
  export default new EventBus();